module.exports = __webpack_public_path__ + "img/logo_groceries.249d6185.svg";